export interface PageInfo {
  total: number;
  /** 1-based index of the first and last row shown (0 when empty). */
  first: number;
  last: number;
  page: number;
  pages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

export function pageInfo(total: number, offset: number, limit: number): PageInfo {
  const pages = Math.max(1, Math.ceil(total / limit));
  const page = Math.floor(offset / limit) + 1;
  const first = total === 0 ? 0 : Math.min(total, offset + 1);
  const last = Math.min(total, offset + limit);
  return { total, first, last, page, pages, hasPrev: offset > 0, hasNext: offset + limit < total };
}
